import React, { useContext } from 'react'
import PaymentSavedInformationPopUp from './PaymentSavedInformationPopUp'
import { usePayment } from '../../hook/payment/usePayment/usePayment'
import PropTypes from 'prop-types'
import { DataContext } from '../../context/DataContext'
import PinflagPaymentMethodList from './PinflagPaymentMethodList'
import { PaymentLoader, SavedCards } from '@pinflag/pinflag-ui-kit'
import { usePaymentHandlers } from '../../hook/payment/usePaymentHandlers'
import GatewayForm from './GatewayForm'

export const PinflagPaymentMethodSelection = ({ scrapperClient }) => {
  const {
    isUsingSavedCards,
    isLoadingCheckIfCustomerHasSavedCards,
    isLoadingCardsData,
    gateway
  } = usePayment()

  const { companyInfo } = useContext(DataContext)

  const { handleSelectCard: handleSelectCardToPay } = usePaymentHandlers({
    scrapperClient
  })

  const { primaryColor } = companyInfo
  const {
    selectedPaymentCard: selectedCardToPay,
    selectedCardToDelete,
    setSelectedCardToDelete,
    deleteCustomerCard,
    cardsData
  } = usePayment()

  const onDeleteCard = () => {
    setSelectedCardToDelete({})
    return deleteCustomerCard(selectedCardToDelete)
  }

  return (
    <>
      <PaymentSavedInformationPopUp />
      {isLoadingCheckIfCustomerHasSavedCards
        ? (
        <PaymentLoader />
          )
        : (
        <div className="flex flex-col px-4 gap-y-3 my-[10px] mx-[27px] md:mt-2 md:max-h-[290px] h-full overflow-y-auto md:overflow-visible div-payment-methods">
          {isUsingSavedCards && (
            <>
              <h2 className="text-[#1C364C] text-[11px] font-semibold">
                Mis tarjetas
              </h2>

              <SavedCards
                selectedCardToPay={selectedCardToPay}
                selectedCardToDelete={selectedCardToDelete}
                cardsData={cardsData}
                handleSelectCardToPay={(card) => handleSelectCardToPay(card)}
                handleSelectCardToDelete={(card) =>
                  setSelectedCardToDelete(card)
                }
                onConfirmDelete={onDeleteCard}
                isLoadingCardsData={isLoadingCardsData}
                primaryColor={primaryColor}
              />
              <h2 className="text-[#1C364C] text-[11px] font-semibold">
                Nuevo método de pago
              </h2>
            </>
          )}
          <PinflagPaymentMethodList scrapperClient={scrapperClient} />
          <GatewayForm gateway={gateway} />
        </div>
          )}
    </>
  )
}

PinflagPaymentMethodSelection.propTypes = {
  scrapperClient: PropTypes.string
}
